<template lang="pug">
  #Article
    v-card(width="100%" height="400",dark )
      .noImage
        v-img(:src="require(`../../assets/img/${article.image}`)" height="100%" style="margin-top:-85px" )
          v-row(align="center" style="height:100%")
            v-col(cols="12" align="center")
              .display-2.font-weight-black.article-title {{article.title}}
    v-container()
      v-card.my-3.mx-auto.align-self-center( )
        //- .noImage()
        //-   v-img.white--text.align-end( :src="article.image" height="200px" )
        //-     v-card-title 
        //-       .display-1 {{article.title}}
        v-card-subtitle
          | {{article.date}}
        v-card-text
          .body-1 {{article.body}}. 
        v-card-actions
          v-spacer
          v-btn.success.text--white( @click="toNewsList" ) Return
</template>

<script>
export default {
  data() {
    return {
      id: '',
      article: {}
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.article = this.$store.getters.getArticle;
    if (!this.article.id) {
      this.$router.push('/welcome/news');
    }
  },
  methods: {
    toNewsList() {
      this.$store.commit('setArticle', {});
      this.$router.push('/welcome/news');
    }
  }
};
</script>

<style lang="stylus" scoped>
.noImage
  background-color var(--v-success-base)
  height 100%
  width 100%
</style>
